import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { App } from '@capacitor/app';
import { URLOpenListenerEvent } from '@capacitor/app/dist/esm/definitions';

@Injectable({
    providedIn: 'root',
})
export class AppCapacitorService {
    public appUrlOpen$ = new BehaviorSubject<URLOpenListenerEvent | null>(null);
    public appUrlOpenChanges$ = this.appUrlOpen$.asObservable();
    constructor() {
        App.addListener('appUrlOpen', (data: URLOpenListenerEvent) => {
            console.log('appUrlOpen ', data);
            this.appUrlOpen$.next(data);
        }).then();
    }
}
